// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__MPY2E","inner":"Footer_inner__3zmPk"};